/* All of the available applications on the FieldBox platform */
export const ORGANIZATION_MANAGEMENT = 'ORGANIZATION_MANAGEMENT'
export const RESOURCES = 'RESOURCES'
export const WORK_ORDER_MANAGEMENT = 'WORK_ORDER_MANAGEMENT'
